export function create_task(description, checked, priority, duedate, id, notes) {
    return { description, checked, priority, duedate, id, notes };
}